import React, { useEffect, useState, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Label, makeStyles, tokens } from "@fluentui/react-components";
import { Add16Filled } from "@fluentui/react-icons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux/store";
import { checkUserPermission } from "../../../../utils";
import { UserPermissionsList } from "../../../../config";

import ContentLoader from "../../../../components/Loader/ContentLoader";
import ASCButton from "../../../../components/Button";
import { getAttitudeToRiskCategoriesListItems } from "../../../../redux/SystemManager/attitudeToRiskCategories";
import NoDataFound from "../../../../components/NoDataFound/noDataFound";
const useStyles = makeStyles({
  field: {
    display: "grid",
    gap: tokens.spacingVerticalS,
    marginBottom: "20px",
  },
  wrapper: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "10px 10px 0",
  },
});
const API_BASE_PATH = "/system-manager/customisations/attitude-risk-categories";
function AttitudeToRiskCategoryHomePage() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { itemId, action } = useParams<{
    itemId: string;
    action?: string;
  }>();
  const { authUser, attitudeToRiskCategories } = useSelector(
    (state: RootState) => ({
      authUser: state.authUser,
      attitudeToRiskCategories: state.attitudeToRiskCategories,
    })
  );
  const styles = useStyles();
  useEffect(() => {
    dispatch(getAttitudeToRiskCategoriesListItems());
  }, [dispatch]);
  useEffect(() => {
    if (attitudeToRiskCategories.listItems.length > 0) {
      navigate(
        `${API_BASE_PATH}/${attitudeToRiskCategories.listItems[0]?.id}/${
          action || "view"
        }`
      );
    }
  }, [action, navigate, attitudeToRiskCategories.listItems]);
  return (
    <div>
      {attitudeToRiskCategories.loading ? (
        <ContentLoader />
      ) : attitudeToRiskCategories.listItems.length === 0 ? (
        <div>
          <div className={styles.wrapper}>
            {checkUserPermission(
              authUser,
              UserPermissionsList.ALLOW_UPDATE_MASTER_DATA
            ) && (
              <ASCButton
                shape="rounded"
                appearance="primary"
                className="asc-button-primary"
                icon={<Add16Filled />}
                size="medium"
                onClick={() => navigate(`${API_BASE_PATH}/add`)}
                label="Add New"
              />
            )}
          </div>
          <NoDataFound />
        </div>
      ) : null}
    </div>
  );
}

export default AttitudeToRiskCategoryHomePage;
